import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
// components
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "../../components/Container";
import Loader from "../../components/Loader";
import AlertMsg from "../../components/AlertMsg";
import { Button } from "@mui/material";
import RolePopup from "./RolePopup";
import RoleCard from "./RoleCard";
// services
import * as Api from "../../api";
import { roleServices } from "../../api/useQueryHooks";
// styles
import "../../assets/css/custom.css";
// constants
import { THEME_COLOR3 } from "../../constants";
// icons
import plusIcon from "../../assets/images/add_plus.svg";

const Roles = () => {
  const [popupState, setPopupState] = useState(false);
  const [msgAlert, setMsgAlert] = useState({
    open: false,
    message: "",
    msgType: "",
  });

  const allRoles = roleServices.useGetAllRoles();

  const allPermissions = useQuery({
    queryKey: ["getAllPermissions"],
    queryFn: () => Api.getAllPermissions(),
    onError: (error) => {
      console.error("Error fetching permissions:", error);
      setMsgAlert({
        open: true,
        message: "Error fetching permissions",
        msgType: "error",
      });
    },
  });

  return (
    <Container
      page={"roles"}
      searchVal={""}
      onSearch={() => null}
      searchLabel="Roles"
    >
      {allRoles?.isLoading ? (
        <Loader height={{ height: window.innerHeight - 150 }} />
      ) : (
        <>
          <Box sx={styles.titleMainBox}>
            <Typography variant={"h6"} sx={styles.userText}>
              Roles
            </Typography>
            <Button
              sx={styles.createButton}
              onClick={() => setPopupState(true)}
            >
              <img src={plusIcon} alt="plus" style={{ marginLeft: 5 }} />
              Create
            </Button>
          </Box>
          {/* role cards  */}
          <Box>
            {allRoles?.data?.data?.rows?.length > 0 ? (
              allRoles?.data?.data?.rows?.map((item, index) => (
                <RoleCard
                  key={index}
                  {...item}
                  setPopupState={setPopupState}
                  setMsgAlert={setMsgAlert}
                />
              ))
            ) : (
              <Grid container direction="row" justifyContent="center">
                <Typography variant={"h6"} sx={styles.userText}>
                  No Roles Found
                </Typography>
              </Grid>
            )}
          </Box>
        </>
      )}
      <AlertMsg
        msgAlert={msgAlert}
        onCloseAlertMsg={() =>
          setMsgAlert({ open: false, message: "", msgType: "error" })
        }
      />
      {allPermissions?.data?.data?.rows?.length && (
        <RolePopup
          open={popupState}
          onClose={() => setPopupState(false)}
          permissionsData={allPermissions?.data?.data?.rows}
          setMsgAlert={setMsgAlert}
        />
      )}
    </Container>
  );
};

export default Roles;

const styles = {
  titleMainBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 2,
  },
  userText: {
    fontFamily: "GilroyBold",
  },
  mainGrid: {
    cursor: "pointer",
    borderRadius: 3,
    width: "100%",
    marginBottom: 2,
    padding: 1.3,
  },
  labelTitle: {
    fontFamily: "GilroyBold",
    fontSize: 14,
  },
  selectList: {
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      fontFamily: "GilroySemiBold",
      fontSize: 13,
      paddingTop: 0.8,
      paddingBottom: 0.8,
    },
  },
  selectListItem: {
    fontFamily: "GilroySemiBold",
    color: THEME_COLOR3,
    fontSize: 13,
  },
  createButton: {
    backgroundColor: "#000",
    color: "#FFF",
    width: 100,
    fontFamily: "GilroyBold",
    fontSize: 14,
    borderRadius: 1,
    "&:hover": {
      backgroundColor: "#000 !important",
    },
  },
};
